import React from "react";

const BatteriesPagination = ({
    page,
    totalPages,
    totalRecords,
    limit,
    onPageChange,
    onLimitChange,
}) => {
    if (totalPages <= 1) return null;

    const getPageNumbers = () => {
        const pages = [];
        const firstVisible = 10;

        if (totalPages <= firstVisible) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
            return pages;
        }

        for (let i = 1; i <= firstVisible; i++) pages.push(i);
        if (page > firstVisible + 2) pages.push("...");

        const start = Math.max(firstVisible + 1, page - 1);
        const end = Math.min(totalPages - 1, page + 1);

        for (let i = start; i <= end; i++) {
            if (!pages.includes(i)) pages.push(i);
        }

        if (end < totalPages - 1) pages.push("...");
        pages.push(totalPages);

        return pages;
    };

    return (
        <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mt-3"
            style={{
                borderTop: "1px solid #dee2e6",
                borderBottom: "1px solid #dee2e6",
                padding: "12px 0",
                marginTop: "20px",
            }}
        >
            <div className="show-entries">
                Showing {(page - 1) * limit + 1} to{" "}
                {Math.min(page * limit, totalRecords)} of {totalRecords} entries
            </div>

            <div className="d-flex align-items-center gap-3">
                <nav>
                    <ul className="custom-pagination mb-0">
                        <li
                            className={`page-btn ${page === 1 ? "disabled" : ""}`}
                            onClick={() => page > 1 && onPageChange(1)}
                        >
                            &laquo;
                        </li>
                        <li
                            className={`page-btn ${page === 1 ? "disabled" : ""}`}
                            onClick={() => page > 1 && onPageChange(page - 1)}
                        >
                            &lt;
                        </li>
                        {getPageNumbers().map((p, index) =>
                            p === "..." ? (
                                <li key={`dots-${index}`} className="page-btn dots">
                                    ...
                                </li>
                            ) : (
                                <li
                                    key={p}
                                    className={`page-btn ${p === page ? "active" : ""}`}
                                    onClick={() => onPageChange(p)}
                                >
                                    {p}
                                </li>
                            )
                        )}
                        <li
                            className={`page-btn ${page === totalPages ? "disabled" : ""}`}
                            onClick={() => page < totalPages && onPageChange(page + 1)}
                        >
                            &gt;
                        </li>
                        <li
                            className={`page-btn ${page === totalPages ? "disabled" : ""}`}
                            onClick={() =>
                                page < totalPages && onPageChange(totalPages)
                            }
                        >
                            &raquo;
                        </li>
                    </ul>
                </nav>

                <div className="d-flex align-items-center" style={{ marginLeft: "10px" }}>
                    <select
                        className="form-control form-control-sm"
                        value={limit}
                        onChange={(e) => onLimitChange(Number(e.target.value))}
                    >
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={150}>150</option>
                        <option value={200}>200</option>
                        <option value={250}>250</option>
                    </select>
                </div>
            </div>
        </div>
    );
};

export default BatteriesPagination;